// Appointment Tab Actions
export const APPOINTMENT_TAB_ACTIONS = {
  GENERATE_FORM: "Appointment Tab  - Generate Form",
  CHANGESTAFF: "Change Staff",
  ASSIGN_MA: "Appointment Tab  - Assign MA",
  RESCHEDULE: "Appointment Tab  - Reschedule",
  PATIENT_CHECKIN: "Appointment Tab  - Patient Checkin",
  PATIENT_NO_SHOW: "Appointment Tab  - Patient No Show",
  INTERPRETER_NO_SHOW: "Appointment Tab  - Interpreter No Show",
  DOCTOR_NO_SHOW: "Appointment Tab  - Doctor No Show",
  CANCEL: "Appointment Tab  - Cancel",
  COMPLETED: "Appointment Tab  - Completed",
};

// Case Actions
export const CASE_ACTIONS = {
  RESUME: "Case Action - Resume",
  ARCHIVE: "Case Action - Archive",
  UNARCHIVE: "Case Action - Unarchive",
  CANCEL: "Case Action - Cancel",
  CLOSE: "Case Action - Close",
};

// Appointment Actions
export const APPOINTMENT_ACTIONS = {
  PATIENT_CHECKIN: "Appointment Actions - Patient Check In",
  PATIENT_NO_SHOW: "Appointment Actions - Patient No Show",
  INTERPRETER_NO_SHOW: "Appointment Actions - Interpreter No Show",
  QME_DOCTOR_NO_SHOW: "Appointment Actions - QME Doctor No Show",
  CANCEL: "Appointment Actions - Cancel",
  GENERATE_110_POS_SIBTF_FORM: "Generate 110 & POS/SIBTF Form",
  VIEW_QME_SCHEDULE: "View QME Schedule",
  DOCTOR_LOCATION_MAP: "Doctors Location Map",
};

// QME Doctor Selection & Basic Details
export const QME_DOCTOR_ACTIONS = {
  SELECTION: "QME Doctor Selection",
  ADD_LOCATION: "Basic Details - Add Location",
  VIEW_LOCATION_MAP: "Basic Details - View Location on Map",
};

// Manage Schedule
export const MANAGE_SCHEDULE_ACTIONS = {
  ADD_MANUAL_LOCATION: "Manage Schedule - Add - Add Manual - Location",
  CANCEL_BULK: "Manage Schedule - Schedule List  - Cancel (Bulk) Schedule",
  DOWNLOAD_APPOINTMENTS:
    "Manage Schedule - View Schedule - Calendar View - Download Appointments",
  CANCEL_SCHEDULE:
    "Manage Schedule - View Schedule - List View - Cancel Schedule",
  RESCHEDULE: "Manage Schedule - View Schedule - List View - Reschedule",
};

// Parties Master
export const PARTIES_MASTER_ACTIONS = {
  CONTACT_ADD: "Parties Master - Contact (Add)",
  CONTACT_REGISTER_USER: "Parties Master - Contact (Add - Register New User)",
  CONTACT_EDIT: "Parties Master - Contact (Edit)",
  CONTACT_VIEW: "Parties Master - Contact (View)",
  PREFERENCES_ADD: "Parties Master - Preferences (Add)",
  PREFERENCES_EDIT: "Parties Master - Preferences (Edit)",
  PREFERENCES_VIEW: "Parties Master - Preferences (View)",
};

// Shared By Me
export const SHARED_BY_ME_ACTIONS = {
  MAIN: "Shared By Me",
  EDIT: "Shared By Me - Edit",
  SHARE_RECORDS: "Shared By Me - Edit - Share Records",
  REVOKE: "Shared By Me - Edit - Share Records - Revoke Action",
  RECORD_DETAILS: "Shared By Me - Share Records - Record Details",
  SHARE_INTERNAL: "Shared By Me - Share Records - Share Details - Internal",
  SHARE_EXTERNAL: "Shared By Me - Share Records - Share Details - External",
  SHARE_EXPIRATION:
    "Shared By Me - Share Records - Share Details - Expiration Limit",
  EDIT_RECORD_DETAILS:
    "Shared By Me - Edit - Share Records - Record Details - Case ID",
};

export const HISTORIAN_ACTIONS = {
  SCHEDULED_DATE: "My ToDo - Schedule Date",
  UPLOAD_RECORDS: "My ToDo - Upload Records",
  ADD_NOTES: "My ToDo - Add Notes",
};
